{
  "DATE_PICKER": {
    "PREVIOUS_PERIOD": "Previous period",
    "NEXT_PERIOD": "Next period",
    "WEEK_NUMBER": "Week #{weekNumber}",
    "APPLY_BUTTON": "درخواست دادن",
    "CLEAR_BUTTON": "پاک کردن",
    "DATE_RANGE_INPUT": {
      "START": "تاریخ شروع",
      "END": "تاریخ پایان"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "محدوده زمانی",
      "LAST_7_DAYS": "در ۷ روز گذشته",
      "LAST_30_DAYS": "در ۳۰ روز گذشته",
      "LAST_3_MONTHS": "۳ ماه گذشته",
      "LAST_6_MONTHS": "۶ ماه گذشته",
      "LAST_YEAR": "پارسال",
      "THIS_WEEK": "This week",
      "MONTH_TO_DATE": "This month",
      "CUSTOM_RANGE": "محدوده تاریخ سفارشی"
    }
  }
}
